import logPerformanceDatapoint from '../helpers/logPerformanceDatapoint';
import addResourceTimingEntryMutator from '../mutators/addResourceTimingEntryMutator';
import { SearchRequestInstrumentation } from 'owa-search-service';
import { PerformanceDatapoint, CalculatedResourceTimings } from 'owa-analytics';

export default function addResourceTimingEntry(
    resourceTimingEntry: CalculatedResourceTimings,
    searchInstrumentationEntry: SearchRequestInstrumentation,
    executeSearchDatapoint: PerformanceDatapoint
) {
    // Add resource timing entry to store
    addResourceTimingEntryMutator(
        searchInstrumentationEntry,
        resourceTimingEntry,
        executeSearchDatapoint
    );

    // Trigger logging of datapoint now that the data is complete
    logPerformanceDatapoint(searchInstrumentationEntry);
}
